import useTranslator from "../../hooks/useTranslator";
import constants from "../../Utils/constants";
import Loginimg from "../../assets/img/skor_login_img.png";
import Logo from "../../assets/img/skorLogo.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import Flag from "../../assets/img/flag.svg";
import { sendUniversalMail } from "../../services/sharedService";
import { haveValue, toast, validateDniNie } from "../../helper/common";
import CheckIcon from "../../assets/img/checkmark-circle-02.svg";
import TenantContext from "../../context/tenant/TenantContext";
import AuthContext from "../../context/auth/AuthContext";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { PhoneInput } from "react-international-phone";
import i18next from "i18next";
import EnterOtpModal from "./enterOtpModal";
import Currencies from "../../Utils/currencies.json";
import { trackClarityEvent } from "../../Utils/clarityReady";
import DatePicker from "react-datepicker";
import { useCookies } from "react-cookie";

const BasicInfoModal = ({
  user,
  formData,
  setFormData,
  createUserProfile,
  formHandler,
  requiresSubcategory,
  isGuarantor,
  guarantorAccountPresent,
  originalUser,
  setGuarantorAccountPresent,
  isEditMode,
  phoneNumber,
  setPhoneNumber,
  selectedProtectedHousingDocs,
  setSelectedProtectedHousingDocs,
  usedFor,
  backBtn,
  companyLogo,
  llGuarantor,
  landlordsDataFromShareProfile,
  isDummySignup,
  setStep,
}) => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const [cookies] = useCookies(["catellaWorkspaceTenant"]);
  const { changeUserLng, sendOTPES, sendOTP } = authContext;
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { getUserByEmail } = useContext(AuthContext);
  const { checkDuplicateDniNie, submitProtectedHousingDocuments } =
    useContext(TenantContext);
  const [isEdited, setIsEdited] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );
  const [foundDuplicateGuarantorFrom, setFoundDuplicateGuarantorFrom] =
    useState(null);
  const [guarantorEmailFromDni, setGuarantorEmailFromDni] = useState(null);
  const [otpModelOpen, setOtpModelOpen] = useState(false);
  const [changedInputFields, setChangedInputFields] = useState([]);
  const [isDropdown, setIsDropdown] = useState(false);
  const [errors, setErrors] = useState({});
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const isProtectedHousingRequired =
    haveValue(cookies?.catellaWorkspaceTenant) || false;

  // Form validations starts
  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "fname":
        if (!value.trim())
          error = _t(
            "firstNameIsRequired",
            "Validation messages used at onboarding"
          );
        else if (!/^[A-Za-zÀ-ÿ\s'-]+$/.test(value)) {
          error = _t(
            "firstNameInvalid",
            "Only letters and basic symbols allowed"
          );
        }
        break;
      case "lname":
        if (!value.trim())
          error = _t(
            "lastNameIsRequired",
            "Validation messages used at onboarding"
          );
        else if (!/^[A-Za-zÀ-ÿ\s'-]+$/.test(value)) {
          error = _t(
            "lnameNameInvalid",
            "Only letters and basic symbols allowed"
          );
        }
        break;
      case "identity_number":
        if (!value.trim())
          error = _t(
            "documentNumberIsRequired",
            "Validation messages used at onboarding"
          );
        else if (!/^[A-Za-z0-9]+$/.test(value))
          error = _t(
            "onlyLettersAndNumbersAreRequired",
            "Validation messages used at onboarding"
          );
        else if (value.length > 9) {
          error = _t(
            "documentNumberCannotExceedNineCharacters",
            "Identity number error"
          );
        }
        break;
      case "post_code":
        if (value.trim() && value.length > 6) {
          error = _t("postCodeCannotExpeedSixCharacters", "Post Code Error");
        }
        break;
      case "dob":
        if (!value.trim()) {
          error = _t(
            "dateOfBirthIsRequired",
            "Validation messages used at onboarding"
          );
        } else {
          const enteredDate = new Date(value);
          const today = new Date();
          const minDate = new Date("1900-01-01");

          if (enteredDate < minDate) {
            error = _t(
              "dateOfBirthCannotBeBefore1900",
              "Validation messages used at onboarding"
            );
          } else if (enteredDate > today) {
            error = _t(
              "dateOfBirthCannotBeInFuture",
              "Validation messages used at onboarding"
            );
          }
        }
        break;

      case "employment_status":
        if (!value)
          error = _t(
            "employmentStatusIsRequired",
            "Validation messages used at onboarding"
          );
        break;
      case "employment_category":
        if (!value)
          error = _t(
            "employemntCategoryIsRequired",
            "Validation messages used at onboarding"
          );
        break;
      case "current_annual_income":
        if (value === "" || value === null || value === undefined)
          error = _t(
            "annualIncomeIsRequired",
            "Validation messages used at onboarding"
          );
        else if (isNaN(value) || Number(value) < 0)
          error = _t(
            "enterAValidIncome",
            "Validation messages used at onboarding"
          );
        break;
      case "currency":
        if (!value)
          error = _t(
            "currencyIsRequired",
            "Validation messages used at onboarding"
          );
        break;
      case "email":
        if (!value.trim())
          error = _t(
            "emailIsRequired",
            "Validation messages used at onboarding"
          );
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value.trim()))
          error = _t(
            "invalidEmailFormat",
            "Validation messages used at onboarding"
          );
        break;
      case "gurantor_relation":
        if (!value.trim())
          error = _t(
            "guarantorRelationIsRequired",
            "Validation messages used at onboarding"
          );
        break;
      default:
        break;
    }

    return error;
  };

  const isFormValid = () => {
    const {
      fname,
      lname,
      identity_number,
      post_code,
      dob,
      employment_status,
      current_annual_income,
      email,
      gurantor_relation,
      employment_category,
      phone_number,
    } = formData;

    const newErrors = {};
    const baseFields = [
      { key: "fname", value: fname },
      { key: "lname", value: lname },
      { key: "identity_number", value: identity_number },
      // { key: "post_code", value: post_code },
      { key: "dob", value: dob },
      { key: "employment_status", value: employment_status },
      { key: "current_annual_income", value: current_annual_income },
    ];

    const guarantorFields = [
      ...baseFields,
      { key: "email", value: email },
      { key: "gurantor_relation", value: gurantor_relation },
    ];

    const tenantFields = [...baseFields];

    const fieldsToValidate =
      isGuarantor || llGuarantor ? guarantorFields : tenantFields;

    fieldsToValidate.forEach(({ key, value }) => {
      const err = validateField(key, value);
      if (err) newErrors[key] = err;
    });

    if (requiresSubcategory(employment_status)) {
      const err = validateField("employment_category", employment_category);
      if (err) newErrors.employment_category = err;
    }

    if (!isGuarantor && isEditMode) {
      const err = validateField("email", email);
      if (err) newErrors.email = err;
    }

    if (!haveValue(phone_number) || phone_number?.length <= 5) {
      console.log("phone number error", phone_number);
      newErrors.phone_number = _t(
        "phoneNumberMustBeAtLeastSixDigits",
        "Validation messages used at onboarding"
      );
    }
    // Protected housing validation
    if (isProtectedHousingRequired) {
      if (
        !Array.isArray(selectedProtectedHousingDocs) ||
        selectedProtectedHousingDocs.length === 0 ||
        selectedProtectedHousingDocs.includes("no")
      ) {
        newErrors.protected_housing = _t(
          "pleaseSelectAtLeastOneOption",
          "Validation messages used at onboarding"
        );
      }
    }

    const identity_type = detectIdentityType(identity_number);
    if (identity_type === "dni" || identity_type === "nie") {
      const valid = validateDniNie(identity_number, identity_type);
      if (!valid) {
        newErrors.identity_number = _t(
          `invalid${identity_type}`,
          "Invalid DNI/NIE number (checksum mismatch)"
        );
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Form validations ends

  const handleCheckboxChange = (value) => {
    setIsEdited(true);
    setErrors((prev) => {
      return {
        ...prev,
        protected_housing: null,
      };
    });
    setChangedInputFields((prev) => [...prev, "protected_housing"]);
    if (value === "no") {
      setSelectedProtectedHousingDocs((prev) =>
        prev.includes("no") ? [] : ["no"]
      );
    } else {
      setSelectedProtectedHousingDocs((prev) => {
        const withoutNo = prev.filter((item) => item !== "no");
        if (withoutNo.includes(value)) {
          return withoutNo.filter((item) => item !== value);
        } else {
          return [...withoutNo, value];
        }
      });
    }
  };

  const handleDetectInputFieldChange = (fieldName, fieldValue) => {
    let updatedFieldName = fieldName;
    if (updatedFieldName === "identity_number") {
      const identity_type = detectIdentityType(fieldValue);
      if (identity_type === "dni" || identity_type === "nie") {
        updatedFieldName = "dni_nie";
      } else {
        updatedFieldName = "passport_id";
      }
    }

    setChangedInputFields((prev) => {
      if (user?.[updatedFieldName] === fieldValue) {
        if (prev.includes(fieldName))
          return prev.filter((f) => f !== fieldName);
      }

      if (!prev.includes(fieldName)) {
        return [...prev, fieldName];
      }

      return prev;
    });
  };

  const handleInputChange = async (e) => {
    if (isGuarantor) {
      setGuarantorAccountPresent(false);
    }
    let { name, value } = e.target;
    if (name === "email") {
      value = value?.toLowerCase();
    }
    if (isEditMode) {
      handleDetectInputFieldChange(name, value);
    }
    setIsEdited(true);
    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        [name]: value,
      };

      if (name === "protected_housing") {
        updatedForm[name] = value === "true";
      }

      // Reset subcategory if employment status changes
      if (name === "employment_status") {
        updatedForm.employment_category = "";
      }

      return updatedForm;
    });
    setErrors((prev) => ({
      ...prev,
      [name]: name === "email" ? null : validateField(name, value),
    }));
  };

  useEffect(() => {
    if (
      localStorage.getItem("usertype") == "tenant" ||
      usedFor === "tenantChecks"
    ) {
      setFormData((prevData) => ({
        ...prevData,
        ["phone_number"]: phoneNumber?.replace("+", ""),
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        ["phone"]: phoneNumber?.replace("+", ""),
      }));
    }
  }, [phoneNumber]);

  function detectIdentityType(identityNumber) {
    if (!identityNumber || typeof identityNumber !== "string") return "unknown";

    const id = identityNumber.toUpperCase().trim();

    const isDNI = /^[0-9]{8,9}[A-Z]$/;
    const isNIE = /^[XYZ][0-9]{7}[A-Z]$/;

    if (isDNI.test(id)) {
      return "dni";
    } else if (isNIE.test(id)) {
      return "nie";
    }

    return "passport";
  }
  // otp functionality start
  let timer = 60;
  let myInterval = null;
  const [otp, setOtp] = useState("");
  const [showResend, setShowResend] = useState(false);
  const [showTimer, setShowTimer] = useState(timer);

  const runTimer = () => {
    if (timer >= 0) {
      myInterval = setInterval(() => {
        setShowTimer((prev) => {
          if (prev > 0) {
            return prev - 1;
          } else {
            resetTimer();
          }
        });
      }, 1000);
    }
  };

  const resetTimer = () => {
    clearInterval(myInterval);
    setShowResend(true);
    setShowTimer(60);
  };

  const sendOtpFun = () => {
    const usertype = localStorage.getItem("usertype");
    const userid = localStorage.getItem("saveduserid");

    if (currentLang === "es") {
      sendOTPES(userid, usertype, formData?.email);
    } else {
      sendOTP(userid, usertype, formData?.email);
    }
    setOtp("");
    setShowResend(false);
    runTimer();
  };
  // otp functionality ends

  const handleSubmitEditedUser = async (emailVerifiedStatus = false) => {
    if (!isFormValid()) {
      trackClarityEvent("tenant_basic_info_step_validation_error");
      return;
    }
    // check for duplicate email
    if (user?.email !== formData.email) {
      const response = await getUserByEmail({
        email: formData.email,
        type: "tenant",
      });
      if (response) {
        const user = response.user;
        if (user) {
          toast.error("emailAlreadyExists");
          trackClarityEvent("tenant_basic_info_step_validation_error");
          return;
        }
      }
    }
    if (changedInputFields.includes("email") && !emailVerifiedStatus) {
      sendOtpFun();
      setOtpModelOpen(true);
      return;
    }
    try {
      let payload = {};
      if (emailVerifiedStatus) {
        setOtpModelOpen(false);
        payload.email = formData?.email;
      }
      handleSubmitStepOne(payload);
    } catch (error) {
      console.log("Error submitted edited user");
    }
  };

  function addQueryParam(key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }

  const handleSubmitStepOne = async (extraFields = null) => {
    const isDummySignupSession = sessionStorage.getItem("isDummySignup");
    if (!isFormValid()) {
      return;
    }

    if (isDummySignupSession) {
      setStep(2);
      return;
    }

    if (isDummySignup) {
      sessionStorage.setItem("isDummySignup", true);
      setOtpModelOpen(true);
      runTimer();
      return;
    }

    let already_present = false;
    if (isEdited || usedFor === "register") {
      const usertype = localStorage.getItem("usertype");
      let formDataCopy = formData;

      if (extraFields !== null) {
        formDataCopy = { ...formDataCopy, ...extraFields };
      }

      formDataCopy.role = usertype;
      formDataCopy.lang = localStorage.getItem("i18nextLng");
      if (!isEditMode) {
        formDataCopy.step = 2;
      }

      const identity_type = detectIdentityType(formDataCopy.identity_number);
      formDataCopy.dni_nie =
        identity_type === "dni" || identity_type === "nie"
          ? formDataCopy.identity_number
          : null;

      formDataCopy.passport_id =
        identity_type === "passport" ? formDataCopy.identity_number : null;

      if (
        (identity_type === "dni" || identity_type === "nie") &&
        usedFor !== "register"
      ) {
        let userid = localStorage.getItem("saveduserid");
        const res = await checkDuplicateDniNie(
          userid,
          formDataCopy.dni_nie,
          formDataCopy.passport_id
        );

        if (res.success_res.already_present?.status) {
          already_present = true;
        }
      }
      let protected_housing = false;
      if (
        !selectedProtectedHousingDocs.includes("no") &&
        selectedProtectedHousingDocs.length > 0
      ) {
        protected_housing = true;
      }

      if (!isGuarantor) {
        formDataCopy.protected_housing = protected_housing;
      }
      console.log("Coming ", cookies.catellaWorkspaceTenant ?? false);
      if (cookies.catellaWorkspaceTenant ?? false) {
        console.log("Coming ");
        formDataCopy.skip_steps = [constants.SKIP_STEPS_ENUM.bank_onboarding];
        setFormData((prev) => ({
          ...prev,
          skip_steps: [constants.SKIP_STEPS_ENUM.bank_onboarding],
        }));
      }
      if (cookies.libeenWorkspaceTenant ?? false) {
        formDataCopy.skip_steps = [
          constants.SKIP_STEPS_ENUM.bank_onboarding,
          constants.SKIP_STEPS_ENUM.guarantor_onboarding,
        ];
        setFormData((prev) => ({
          ...prev,
          skip_steps: [
            constants.SKIP_STEPS_ENUM.bank_onboarding,
            constants.SKIP_STEPS_ENUM.guarantor_onboarding,
          ],
        }));
      }

      if (already_present) {
        toast.error(_t("dniNieAlreadyUsedByAnotherTenantProfile"));
      } else {
        try {
          setSubmitLoading(true);
          if (
            !isGuarantor &&
            usedFor !== "register" &&
            usedFor !== "tenantChecks"
          ) {
            const payload = {
              allDocuments: Array.isArray(selectedProtectedHousingDocs)
                ? selectedProtectedHousingDocs
                : [],
            };
            await submitProtectedHousingDocuments(
              protected_housing ? payload : []
            );
          }
          if (!isEditMode && usedFor !== "tenantChecks") {
            addQueryParam("welcome", "true");
          }
          await createUserProfile(formDataCopy);

          if (isEditMode) {
            if (
              ![
                "identity_number",
                "employment_status",
                "employment_category",
                "protected_housing",
              ].some((field) => changedInputFields.includes(field))
            ) {
              navigate(
                haveValue(workspaceId) ? `/${workspaceId}/home` : `/home`
              );
              return;
            }
          }
        } catch (err) {
          console.log("Error in submitting first step");
          return;
        } finally {
          setSubmitLoading(false);
        }
      }
    }
    if (!isGuarantor && !already_present) {
      if (isEditMode) {
        if (
          [
            "identity_number",
            "employment_status",
            "employment_category",
            "protected_housing",
          ].some((field) => changedInputFields.includes(field))
        ) {
          formHandler.next();
        } else {
          navigate(haveValue(workspaceId) ? `/${workspaceId}/home` : `/home`);
        }
      } else {
        if (usedFor !== "register") {
          formHandler.next();
        }
      }
    }
  };

  const sendMail = (receiverEmail, emailType) => {
    let payload = {
      receiverEmail: receiverEmail,
      senderId: localStorage.getItem("saveduserid"),
      emailType: emailType,
      status: "present",
    };
    sendUniversalMail(payload)
      .then((res) => {
        toast.success(_t("emailSent"));
      })
      .catch((err) => {
        toast.error(_t("errorSendingMail"), err?.message);
        console.log(err);
      });
  };

  const handleSendEmailToGuarantor = async () => {
    if (formData?.email === originalUser?.email) {
      toast.error(
        _t(
          "youCannotAddYourselfAsGuarantor",
          "Error message when a user is try to add guarantor but add his/her own email"
        )
      );
      return;
    }
    const email =
      foundDuplicateGuarantorFrom === "dni_nie_pass"
        ? guarantorEmailFromDni
        : formData?.email;

    sendMail(email, "score");
    navigate(haveValue(workspaceId) ? `/${workspaceId}/home` : `/home`);
    toast.success(_t("emailSentToGuarantor"));
  };

  const checkDuplicateDniForGuarantor = async () => {
    setFoundDuplicateGuarantorFrom(null);
    setGuarantorEmailFromDni(null);

    let dni_nie = null,
      passport = null;

    const identity_type = detectIdentityType(formData.identity_number);
    dni_nie =
      identity_type === "dni" || identity_type === "nie"
        ? formData.identity_number
        : null;

    passport = identity_type === "passport" ? formData.identity_number : null;

    const res = await checkDuplicateDniNie(
      haveValue(user?._id) ? user._id : null,
      dni_nie,
      passport,
      true
    );

    if (res.success_res.already_present) {
      setGuarantorEmailFromDni(res.success_res?.email ?? null);
      setErrors({});
      setGuarantorAccountPresent(true);
      setFoundDuplicateGuarantorFrom("dni_nie_pass");
    }
  };

  const checkEmailPresent = async () => {
    setFoundDuplicateGuarantorFrom(null);

    const response = await getUserByEmail({
      email: formData.email,
      type: "tenant",
    });
    if (response) {
      const user = response.user;
      if (user) {
        setErrors({});
        setGuarantorAccountPresent(true);
        setFoundDuplicateGuarantorFrom("email");
      }
    }
  };

  const handleLanguageChange = async (langVal) => {
    await i18next.changeLanguage(langVal);
    await changeUserLng();
    setCurrentLang(langVal);
  };

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  function compressEmail(email) {
    if (!email || !email.includes("@")) return email;

    const [localPart, domainPart] = email.split("@");

    const compressedLocal = localPart[0] + localPart.slice(-2);

    return `${compressedLocal}@${domainPart}`;
  }

  const allDocuments = [
    {
      value: "no",
      label: _t("no", "Public Housing Certificates"),
    },
    {
      value: constants.regulatory_agreement_in_case_of_divorce_separation,
      label: _t(
        "regulatoryAgreementInCaseOfDivorceSeparation",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.revalued_pension_certificate,
      label: _t("revaluedPensionCertificate", "Public Housing Certificates"),
    },
    {
      value: constants.family_book_marriage_civil_partnership_birth_certificate,
      label: _t(
        "familyBookMarriageCivilPartnershipBirthCertificate",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.certificate_of_social_security_compliance,
      label: _t(
        "certificateProvingDisabilityStatus",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.no_special_circumstances,
      label: _t(
        "noSpecialCircumstances",
        "No special circumstances that require protected housing"
      ),
    },
  ];

  const formatNumber = (value, locale) => {
    if (value === null || value === undefined || value === "") return "";
    return new Intl.NumberFormat(locale).format(
      String(value).replace(/\D/g, "")
    );
  };

  return (
    <div
      className={`bigform ${
        usedFor === "tenantChecks" ? "tenantChecksForm" : ""
      }`}
      onClick={() => setIsDropdown(false)}
    >
      {usedFor === "tenantChecks" && (
        <div
          onClick={() => navigate(`/${workspaceId}/created-tenant`)}
          className="cursor-pointer goBackButtonTenant d-flex align-items-center justify-content-center"
        >
          <img src="/images/arrow-right.svg" className="arrow-left" />
        </div>
      )}
      <div className="form-left">
        <img src={Loginimg} alt="login" className="form-image" />
      </div>
      <div
        className={`form-right overflow-y-scroll ${
          isGuarantor || llGuarantor
            ? "popup-overlay fixed inset-0 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen guarantorBg"
            : ""
        }`}
        style={{ width: isGuarantor || llGuarantor ? "100%" : "" }}
      >
        <div
          className={`form-inner ${llGuarantor ? "tenantCheckForm" : ""}`}
          style={{ width: isGuarantor || llGuarantor ? "50vw" : "" }}
          onClick={
            isGuarantor || llGuarantor ? (e) => e.stopPropagation() : null
          }
        >
          {!isGuarantor && !llGuarantor && (
            <div
              className={`logoWrapper ${
                haveValue(companyLogo) ? "withCompanyLogo" : ""
              }`}
            >
              <div className="form_logo">
                {haveValue(companyLogo) ? (
                  <>
                    <img
                      className="company-logo"
                      src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${companyLogo}`}
                      alt=""
                    />
                    <div className="d-flex align-items-center justify-content-center custom-gap-2 poweredByWrapper">
                      <p className="poweredBy">{_t("poweredBy")}</p>
                      <img
                        src={Logo}
                        alt="Powered By Logo"
                        className="poweredByLogo"
                      />
                    </div>
                  </>
                ) : (
                  <img src={Logo} alt="logo" />
                )}
              </div>

              {currentLang == "es" ? (
                <div
                  className="language-switch-container language-switch-container-es  cursor-pointer"
                  onClick={(e) => handleLanguageChange("en-us")}
                >
                  <p>ES</p>
                  <img
                    className="flag-image"
                    alt="Flag"
                    src="/images/spain-flag.png"
                  />
                </div>
              ) : (
                <div
                  className="language-switch-container cursor-pointer"
                  onClick={(e) => handleLanguageChange("es")}
                >
                  <img className="flag-image" alt="Flag" src={Flag} />
                  <p>EN</p>
                </div>
              )}
            </div>
          )}
          <form className="forminfomation">
            <div className="form_logo form_logo_mobile">
              {haveValue(companyLogo) ? (
                <>
                  <img
                    className="company-logo"
                    src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${companyLogo}`}
                    alt=""
                  />
                  <div className="d-flex align-items-center justify-content-center custom-gap-2 poweredByWrapper">
                    <p className="poweredBy">{_t("poweredBy")}</p>
                    <img
                      src={Logo}
                      alt="Powered By Logo"
                      className="poweredByLogo"
                    />
                  </div>
                </>
              ) : (
                <img src={Logo} alt="logo" />
              )}
            </div>
            {usedFor === "register" && (
              <div
                className="cursor-pointer goBackButtonWrapper"
                onClick={backBtn}
              >
                <img src="/images/arrow-right.svg" className="arrow-left" />
                <p>{_t("goBack")}</p>
              </div>
            )}
            {isGuarantor && !llGuarantor && (
              <div className="d-flex justify-content-between align-items-center guarantorDetailsHeader">
                <h3 className="guarantorDetailsHeading">
                  {_t("guarantorDetails")}
                </h3>
                <div className="d-flex align-items-center custom-gap-2">
                  {guarantorAccountPresent && (
                    <button className="bankStatementButton bankAddedButton guarantorAlreadyPresent">
                      <img src={CheckIcon} />
                      {_t("guarantorAlreadyPresent")}
                    </button>
                  )}
                  {isGuarantor && (
                    <div
                      className="cursor-pointer"
                      onClick={() => navigate("/home")}
                    >
                      <img
                        src={Cancelimg}
                        alt="icon"
                        className="canceicon topRightIcon"
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
            {usedFor === "tenantChecks" && !llGuarantor && (
              <h3 className="guarantorDetailsHeading completeTenantChecks">
                {_t("completeTenantChecks")}
              </h3>
            )}
            {llGuarantor && (
              <>
                <h3 className="guarantorDetailsHeading completeTenantChecks">
                  {_t("addGuarantorDetails")}
                </h3>
                <p className="completeTenantChecksDes text-center">
                  {_t("pleaseAdGuarantorDetailsBelow")}
                </p>
              </>
            )}
            <div className="form-grid grid grid-cols-1 md:grid-cols-2 custom-gap-2">
              <div className="main-form-group">
                <div
                  className={`form-group ${
                    errors.fname ? "form-group-error" : ""
                  }`}
                >
                  <label>{_t("firstName")}</label>
                  <input
                    type="text"
                    placeholder={_t(
                      "enterFirstName",
                      "Text used in onboarding process"
                    )}
                    name="fname"
                    value={formData.fname}
                    required
                    onChange={handleInputChange}
                    onBeforeInput={(e) => {
                      const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
                      if (!isValidChar) e.preventDefault();
                    }}
                  />
                </div>

                {errors.fname && (
                  <p className="error-message">{errors.fname}</p>
                )}
              </div>

              <div className="main-form-group">
                <div
                  className={`form-group ${
                    errors.lname ? "form-group-error" : ""
                  }`}
                >
                  <label>{_t("lastName")}</label>
                  <input
                    type="text"
                    placeholder={_t(
                      "enterLastName",
                      "Text used in onboarding process"
                    )}
                    name="lname"
                    value={formData.lname}
                    required
                    onChange={handleInputChange}
                    onBeforeInput={(e) => {
                      const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
                      if (!isValidChar) e.preventDefault();
                    }}
                  />
                </div>
                {errors.lname && (
                  <p className="error-message">{errors.lname}</p>
                )}
              </div>
              {(isGuarantor || llGuarantor) && (
                <div className="main-form-group">
                  <div
                    className={`form-group ${
                      errors.gurantor_relation ? "form-group-error" : ""
                    }`}
                  >
                    <label>
                      {_t(
                        "relationshipWithGuarantor",
                        "Text used in onboarding process"
                      )}
                    </label>
                    <select
                      name="gurantor_relation"
                      value={formData?.gurantor_relation}
                      onChange={handleInputChange}
                      style={{
                        color:
                          (!haveValue(formData?.gurantor_relation) ||
                            formData?.gurantor_relation === "") &&
                          "#7f7f7f",
                      }}
                    >
                      <option value="" selected disabled hidden>
                        {_t("pleaseSelect")}
                      </option>
                      <option value="parent">{_t("parent")}</option>
                      <option value="Family">{_t("Family")}</option>
                      <option value="relative">{_t("relative")}</option>
                      <option value="partner">{_t("partner")}</option>
                      <option value="company">{_t("company")}</option>
                      <option value="other">{_t("other")}</option>
                    </select>
                    <img
                      src="/images/down-arrow-grey.svg"
                      className="downArrow"
                    />
                  </div>
                  {errors.gurantor_relation && (
                    <p className="error-message">{errors.gurantor_relation}</p>
                  )}
                </div>
              )}

              <div className="main-form-group mobile-tenant-form-field">
                <div
                  className={`form-group ${
                    errors.identity_number ? "form-group-error" : ""
                  } ${
                    guarantorAccountPresent &&
                    foundDuplicateGuarantorFrom === "email" &&
                    "input-disabled"
                  }`}
                >
                  <label>
                    {_t("dniNieOrPassport", "Text used in onboarding process")}
                  </label>
                  {guarantorAccountPresent &&
                  foundDuplicateGuarantorFrom === "email" ? (
                    <div className="d-flex flex-wrap">
                      {Array(8)
                        .fill(8)
                        .map((_, index) => (
                          <span key={index} className="dot" />
                        ))}
                    </div>
                  ) : (
                    <input
                      type="text"
                      placeholder={_t(
                        "enterDniOrPassport",
                        "Text used in onboarding process"
                      )}
                      name="identity_number"
                      value={formData.identity_number}
                      required
                      onChange={handleInputChange}
                      maxLength={9}
                      onBlur={() =>
                        isGuarantor ? checkDuplicateDniForGuarantor() : {}
                      }
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];

                        if (
                          !e.key.match(/^[a-zA-Z0-9]$/) &&
                          !allowedKeys.includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  )}
                </div>
                {errors.identity_number && (
                  <p className="error-message">{errors.identity_number}</p>
                )}
              </div>

              <div className="main-form-group mobile-tenant-form-field">
                <div
                  className={`form-group ${
                    errors.email ? "form-group-error" : ""
                  } ${
                    ((guarantorAccountPresent &&
                      foundDuplicateGuarantorFrom === "dni_nie_pass") ||
                      !(
                        isGuarantor ||
                        isEditMode ||
                        usedFor === "tenantChecks"
                      )) &&
                    "input-disabled"
                  }`}
                >
                  <label>
                    {_t("email", "Text used in onboarding process")}
                  </label>
                  {guarantorAccountPresent &&
                  foundDuplicateGuarantorFrom === "dni_nie_pass" ? (
                    <div className="d-flex flex-wrap align-items-center dotWrapper">
                      {Array(6)
                        .fill(6)
                        .map((_, index) => (
                          <span key={index} className="dot" />
                        ))}
                      <span className="emailText">
                        {compressEmail(guarantorEmailFromDni)}
                      </span>
                    </div>
                  ) : (
                    <input
                      type="email"
                      placeholder={_t(
                        "enterYourEmail",
                        "Text used in onboarding process"
                      )}
                      name="email"
                      value={
                        isDummySignup
                          ? sessionStorage.getItem("dummy_email") ||
                            formData.email
                          : formData.email
                      }
                      required
                      onChange={handleInputChange}
                      disabled={
                        !(
                          isGuarantor ||
                          isEditMode ||
                          usedFor === "tenantChecks"
                        )
                      }
                      onBlur={() => (isGuarantor ? checkEmailPresent() : {})}
                    />
                  )}
                </div>
                {errors.email && (
                  <p className="error-message">{errors.email}</p>
                )}
              </div>

              <div className="main-form-group mobile-tenant-form-field">
                <div
                  className={`form-group ${
                    errors.phone_number ? "form-group-error" : ""
                  } ${guarantorAccountPresent && "input-disabled"}`}
                >
                  <label>
                    {_t("phoneNumber", "Text used in onboarding process")}
                  </label>
                  {guarantorAccountPresent ? (
                    <div className="d-flex flex-wrap">
                      {Array(8)
                        .fill(8)
                        .map((_, index) => (
                          <span key={index} className="dot" />
                        ))}
                    </div>
                  ) : (
                    <PhoneInput
                      className="phone_input_info"
                      international
                      defaultCountry={"es"}
                      value={
                        isDummySignup ? phoneNumber : formData.phone_number
                      }
                      onChange={(e) => {
                        setIsEdited(true);
                        setErrors((prev) => ({
                          ...prev,
                          phone_number: null,
                        }));
                        setPhoneNumber(e);
                      }}
                    />
                  )}
                </div>
                {errors.phone_number && (
                  <p className="error-message">{errors.phone_number}</p>
                )}
              </div>

              <div className="main-small-group-wrapper">
                <div className="main-form-group main-small-group">
                  <div
                    className={`form-group ${
                      errors.post_code ? "form-group-error" : ""
                    } small-group ${
                      guarantorAccountPresent && "input-disabled"
                    }`}
                  >
                    <label>{_t("postCode")}</label>
                    {guarantorAccountPresent ? (
                      <div className="d-flex flex-wrap">
                        {Array(8)
                          .fill(8)
                          .map((_, index) => (
                            <span key={index} className="dot" />
                          ))}
                      </div>
                    ) : (
                      <input
                        type="number"
                        placeholder={_t(
                          "enterPostCode",
                          "Text used in onboarding process"
                        )}
                        name="post_code"
                        value={formData.post_code}
                        required
                        onChange={(e) => {
                          if (e.target?.value?.length <= 5) {
                            handleInputChange(e);
                          }
                        }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];

                          if (
                            !e.key.match(/^[0-9]$/) &&
                            !allowedKeys.includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  </div>
                  {errors.post_code && (
                    <p className="error-message">{errors.post_code}</p>
                  )}
                </div>
                <div className="main-form-group main-small-group">
                  <div
                    className={`form-group ${
                      errors.dob ? "form-group-error" : ""
                    } small-group ${
                      guarantorAccountPresent && "input-disabled"
                    }`}
                  >
                    <label htmlFor="dob">{_t("dateofbirth")}</label>
                    {guarantorAccountPresent ? (
                      <div className="d-flex flex-wrap">
                        {Array(8)
                          .fill(8)
                          .map((_, index) => (
                            <span key={index} className="dot" />
                          ))}
                      </div>
                    ) : (
                      <div className="native-like-datepicker">
                        <DatePicker
                          id="dob"
                          name="dob"
                          selected={
                            formData?.dob ? new Date(formData.dob) : null
                          }
                          open={isCalendarOpen}
                          onClickOutside={() => setIsCalendarOpen(false)}
                          onSelect={() => setIsCalendarOpen(false)}
                          onInputClick={() => {}}
                          onChange={(date) => {
                            let value = "";
                            if (date && !isNaN(date.getTime())) {
                              const year = date.getFullYear();
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, "0");
                              const day = String(date.getDate()).padStart(
                                2,
                                "0"
                              );
                              value = `${year}-${month}-${day}`;
                            }
                            handleInputChange({
                              target: {
                                name: "dob",
                                value: value,
                              },
                            });
                          }}
                          onChangeRaw={(e) => {
                            if (
                              e.target.value &&
                              (!e.nativeEvent.inputType ||
                                !e.nativeEvent.inputType.startsWith("delete"))
                            ) {
                              let val = e.target.value.replace(/\D/g, "");
                              if (val.length > 8) val = val.substring(0, 8);
                              if (val.length >= 5) {
                                e.target.value = `${val.substring(0, 2)}/${val.substring(2, 4)}/${val.substring(4)}`;
                              } else if (val.length >= 3) {
                                e.target.value = `${val.substring(0, 2)}/${val.substring(2)}`;
                              } else {
                                e.target.value = val;
                              }
                            }
                          }}
                          dateFormat={[
                            "dd/MM/yyyy",
                            "ddMMyyyy",
                            "dd-MM-yyyy",
                            "dd.MM.yyyy",
                          ]}
                          minDate={new Date("1900-01-01")}
                          maxDate={new Date()}
                          placeholderText="dd/mm/yyyy"
                          className={`date-input ${
                            !haveValue(formData?.dob) ? "empty" : ""
                          }`}
                          showPopperArrow={false}
                          popperPlacement="bottom-start"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          openToDate={
                            formData?.dob
                              ? new Date(formData.dob)
                              : new Date(new Date().getFullYear() - 25, 0, 1)
                          }
                          renderCustomHeader={({
                            date,
                            changeYear,
                            changeMonth,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                          }) => (
                            <div className="datepicker-custom-header">
                              <div className="datepicker-header-left w-100 justify-content-between px-2">
                                <div className="datepicker-selection-item">
                                  <span className="datepicker-current-title">
                                    {date.toLocaleString("default", {
                                      month: "long",
                                    })}
                                  </span>
                                  <svg
                                    className="datepicker-dropdown-arrow ms-1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    style={{ width: "12px", height: "12px" }}
                                  >
                                    <path
                                      d="M6 9l6 6 6-6"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  <select
                                    value={date.getMonth()}
                                    onChange={({ target: { value } }) =>
                                      changeMonth(Number(value))
                                    }
                                    className="datepicker-invisible-select"
                                  >
                                    {Array.from({ length: 12 }, (_, i) => (
                                      <option key={i} value={i}>
                                        {new Date(0, i).toLocaleString(
                                          "default",
                                          { month: "long" }
                                        )}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="datepicker-selection-item">
                                  <span className="datepicker-current-title">
                                    {date.getFullYear()}
                                  </span>
                                  <svg
                                    className="datepicker-dropdown-arrow ms-1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    style={{ width: "12px", height: "12px" }}
                                  >
                                    <path
                                      d="M6 9l6 6 6-6"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  <select
                                    value={date.getFullYear()}
                                    onChange={({ target: { value } }) =>
                                      changeYear(Number(value))
                                    }
                                    className="datepicker-invisible-select"
                                  >
                                    {Array.from(
                                      { length: 121 },
                                      (_, i) => 1900 + i
                                    ).map((year) => (
                                      <option key={year} value={year}>
                                        {year}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        >
                          <div className="datepicker-footer">
                            <button
                              type="button"
                              className="datepicker-footer-btn"
                              onClick={() => {
                                handleInputChange({
                                  target: { name: "dob", value: "" },
                                });
                                setIsCalendarOpen(false);
                              }}
                            >
                              Clear
                            </button>
                            <button
                              type="button"
                              className="datepicker-footer-btn"
                              onClick={() => {
                                const today = new Date();
                                const year = today.getFullYear();
                                const month = String(
                                  today.getMonth() + 1
                                ).padStart(2, "0");
                                const day = String(today.getDate()).padStart(
                                  2,
                                  "0"
                                );
                                handleInputChange({
                                  target: {
                                    name: "dob",
                                    value: `${year}-${month}-${day}`,
                                  },
                                });
                                setIsCalendarOpen(false);
                              }}
                            >
                              Today
                            </button>
                          </div>
                        </DatePicker>
                        <span
                          className="calendar-icon cursor-pointer"
                          onClick={() => setIsCalendarOpen((prev) => !prev)}
                        >
                          <img
                            src="/images/calendar-icon.svg"
                            alt="Calendar Icon"
                          />
                        </span>
                      </div>
                    )}
                  </div>
                  {errors.dob && <p className="error-message">{errors.dob}</p>}
                </div>
              </div>

              <div className="main-form-group">
                <div
                  className={`form-group ${
                    errors.employment_status ? "form-group-error" : ""
                  } ${guarantorAccountPresent && "input-disabled"}`}
                >
                  <label htmlFor="employment_status">
                    {_t("employmentStatus")}
                  </label>
                  {guarantorAccountPresent ? (
                    <div className="d-flex flex-wrap">
                      {Array(8)
                        .fill(8)
                        .map((_, index) => (
                          <span key={index} className="dot" />
                        ))}
                    </div>
                  ) : (
                    <>
                      <select
                        id="employment_status"
                        name="employment_status"
                        value={
                          formData?.employment_status !== undefined ||
                          formData?.employment_status !== ""
                            ? formData?.employment_status
                            : ""
                        }
                        onChange={handleInputChange}
                        style={{
                          color:
                            (!haveValue(formData?.employment_status) ||
                              formData?.employment_status === "") &&
                            "#7f7f7f",
                        }}
                      >
                        <option value="" disabled>
                          {_t("pleaseSelect")}
                        </option>
                        <option value={constants.employed}>
                          {_t("employed")}
                        </option>
                        <option value={constants.self_employed}>
                          {_t("selfEmployed")}
                        </option>
                        <option value={constants.student}>
                          {_t("student")}
                        </option>
                        <option value={constants.unemployed}>
                          {_t("unemployed")}{" "}
                        </option>
                        <option value={constants.retired}>
                          {_t("retired")}{" "}
                        </option>
                        <option value={constants.public_servant}>
                          {_t(constants.public_servant)}
                        </option>
                      </select>
                      <img
                        src="/images/down-arrow-grey.svg"
                        className="downArrow"
                      />
                    </>
                  )}
                </div>
                {errors.employment_status && (
                  <p className="error-message">{errors.employment_status}</p>
                )}
              </div>

              {(requiresSubcategory(formData?.employment_status) ?? "") && (
                <div className="main-form-group">
                  <div
                    className={`form-group ${
                      errors.employment_category ? "form-group-error" : ""
                    } ${guarantorAccountPresent && "input-disabled"}`}
                  >
                    <label>{_t("employmentCategory")}</label>
                    {guarantorAccountPresent ? (
                      <div className="d-flex flex-wrap">
                        {Array(8)
                          .fill(8)
                          .map((_, index) => (
                            <span key={index} className="dot" />
                          ))}
                      </div>
                    ) : (
                      <>
                        <select
                          name="employment_category"
                          value={formData?.employment_category}
                          onChange={handleInputChange}
                          style={{
                            color:
                              (!haveValue(formData?.employment_category) ||
                                formData?.employment_category === "") &&
                              "#7f7f7f",
                          }}
                        >
                          <option value="" disabled>
                            {_t("pleaseSelect")}
                          </option>
                          {(() => {
                            let subcategories = [];
                            if (
                              formData?.employment_status ===
                              constants.public_servant
                            ) {
                              subcategories =
                                constants.public_servant_subcategories;
                            } else if (
                              formData?.employment_status === constants.employed
                            ) {
                              subcategories = constants.employed_subcategories;
                            } else if (
                              formData?.employment_status ===
                              constants.self_employed
                            ) {
                              subcategories =
                                constants.self_employed_subcategories;
                            }

                            return subcategories.map((item) => (
                              <option key={item} value={item}>
                                {_t(item)}
                              </option>
                            ));
                          })()}
                        </select>
                        <img
                          src="/images/down-arrow-grey.svg"
                          className="downArrow"
                        />
                      </>
                    )}
                  </div>
                  {errors.employment_category && (
                    <p className="error-message">
                      {errors.employment_category}
                    </p>
                  )}
                </div>
              )}

              <div className="main-form-group">
                <div
                  className={`form-group ${
                    errors.current_annual_income ? "form-group-error" : ""
                  } ${guarantorAccountPresent && "input-disabled"}`}
                >
                  <label>
                    {_t(
                      "averageNetMonthlyIncome",
                      "Text used in onboarding process"
                    )}
                  </label>
                  {guarantorAccountPresent ? (
                    <div className="d-flex flex-wrap">
                      {Array(8)
                        .fill(8)
                        .map((_, index) => (
                          <span key={index} className="dot" />
                        ))}
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-between">
                      <input
                        type="text"
                        name="current_annual_income"
                        placeholder={_t(
                          "enterNetIncome",
                          "Text used in onboarding process"
                        )}
                        style={{ width: "85%" }}
                        value={formatNumber(
                          formData.current_annual_income,
                          localStorage.getItem("i18nextLng") === "es"
                            ? "es-ES"
                            : "en-US"
                        )}
                        className="income-input"
                        onChange={(e) => {
                          const raw = e.target.value.replace(/\D/g, "");
                          handleInputChange({
                            target: {
                              name: "current_annual_income",
                              value: raw,
                            },
                          });
                        }}
                      />
                      <select
                        id="currency"
                        name="currency"
                        className="currency-select"
                        value={formData?.currency}
                        onChange={handleInputChange}
                        style={{
                          color:
                            (!haveValue(formData?.currency) ||
                              formData?.currency === "") &&
                            "#7f7f7f",
                          opacity: 0,
                        }}
                      >
                        {Object.keys(Currencies).map((data) => (
                          <option key={data} value={data}>
                            {`${data} - ${Currencies[data]?.[currentLang]}`}
                          </option>
                        ))}
                      </select>
                      <img
                        src="/images/down-arrow-grey.svg"
                        className="downArrow downArrowCurrency"
                      />

                      <div className="selected-value-currency">
                        {formData?.currency}
                      </div>
                    </div>
                  )}
                </div>
                {errors.current_annual_income && (
                  <p className="error-message">
                    {errors.current_annual_income}
                  </p>
                )}
              </div>

              {((!isGuarantor &&
                !llGuarantor &&
                landlordsDataFromShareProfile?.protected_housing_enabled !==
                  false &&
                (!haveValue(user?.workspaceId) ||
                  user?.workspaceId?.protected_housing_enabled)) ||
                isProtectedHousingRequired) && (
                <div className="main-form-group mobile-tenant-form-field">
                  <div
                    className={`form-group ${
                      errors.protected_housing ? "form-group-error" : ""
                    } position-relative form-group-last cursor-pointer`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsDropdown(!isDropdown);
                    }}
                  >
                    <label>
                      {_t(
                        "qualifyOrApplyingToProtectingProperty",
                        "Text used in onboarding process"
                      )}
                    </label>
                    <div className="selected-values">
                      {selectedProtectedHousingDocs?.length > 0
                        ? selectedProtectedHousingDocs?.includes("no")
                          ? selectedProtectedHousingDocs[0]
                          : `${selectedProtectedHousingDocs?.length} ${
                              selectedProtectedHousingDocs?.length === 1
                                ? _t("optionSelected")
                                : _t("optionsSelected")
                            }`
                        : _t("selectAnOption")}
                    </div>
                    <img
                      src="/images/down-arrow-grey.svg"
                      className="downArrow"
                    />
                    {isDropdown && (
                      <div
                        className="editDeleteDropdown checkboxListDropdown w-100"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {allDocuments
                          .filter(
                            (doc) =>
                              !isProtectedHousingRequired || doc.value !== "no"
                          )
                          .map((doc) => (
                            <div className="checkboxWrapper" key={doc.value}>
                              <label className="custom-gap-3 custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={selectedProtectedHousingDocs.includes(
                                    doc.value
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(doc.value)
                                  }
                                />
                                <span className="custom-checkmark"></span>
                                {doc.label}
                              </label>
                            </div>
                          ))}
                      </div>
                    )}
                    {errors.protected_housing && (
                      <p className="error-message">
                        {errors.protected_housing}
                      </p>
                    )}
                  </div>
                </div>
              )}

              <div className="form-button mt-0">
                {llGuarantor && (
                  <button
                    type="button"
                    className="btnNext btnnextpre mr-2"
                    onClick={formHandler.prev}
                  >
                    {_t("back")}
                  </button>
                )}
                {guarantorAccountPresent ? (
                  <button
                    type="button"
                    className="btnNext basicInfoButton greenHover"
                    disabled={
                      !haveValue(formData?.email) &&
                      !haveValue(guarantorEmailFromDni)
                    }
                    onClick={handleSendEmailToGuarantor}
                  >
                    {_t("sendRequestToAddGuarantor")}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btnNext basicInfoButton greenHover"
                    onClick={() => {
                      if (isEditMode) {
                        handleSubmitEditedUser();
                      } else {
                        handleSubmitStepOne();
                      }
                    }}
                    disabled={submitLoading}
                  >
                    {submitLoading
                      ? _t("submitting", "Text used in onboarding process")
                      : isEditMode &&
                          ![
                            "email",
                            "identity_number",
                            "employment_status",
                            "employment_category",
                            "protected_housing",
                          ].some((field) => changedInputFields.includes(field))
                        ? _t("submit")
                        : _t("next")}
                  </button>
                )}
              </div>
            </div>
            {!isGuarantor && !llGuarantor && (
              <p className="cookiesdiv cookiesdiv_mobile">
                {_t(
                  "byClickingNextYouAcceptAllThe",
                  "Text used in onboarding process"
                )}
                <div className="tems-links-wrapper">
                  <Link to="https://skortorent.com/terms-conditions.html">
                    {_t(
                      "termsAndConditions",
                      "Text used in onboarding process"
                    )}
                  </Link>
                  <Link to="https://skortorent.com/privacy-policy.html">
                    {_t("privacyPolicy", "Text used in onboarding process")}
                  </Link>
                  <Link to="https://skortorent.com/cookies.html">
                    {_t("cookiePolicy", "Text used in onboarding process")}
                  </Link>
                  <Link to="https://skortorent.com/legal-notice.html">
                    {_t("legalNotice", "Text used in onboarding process")}
                  </Link>
                </div>
              </p>
            )}
          </form>
          {!isGuarantor && !llGuarantor && (
            <p className="cookiesdiv">
              {_t(
                "byClickingNextYouAcceptAllThe",
                "Text used in onboarding process"
              )}
              <Link to="https://skortorent.com/terms-conditions.html">
                {_t("termsAndConditions", "Text used in onboarding process")}
              </Link>
              <Link to="https://skortorent.com/privacy-policy.html">
                {_t("privacyPolicy", "Text used in onboarding process")}
              </Link>
              <Link to="https://skortorent.com/cookies.html">
                {_t("cookiePolicy", "Text used in onboarding process")}
              </Link>
              <Link to="https://skortorent.com/legal-notice.html">
                {_t("legalNotice", "Text used in onboarding process")}
              </Link>
            </p>
          )}
        </div>
      </div>
      {otpModelOpen && (
        <EnterOtpModal
          isGuarantor={isGuarantor}
          onClose={() => setOtpModelOpen(false)}
          handleSubmitEditedUser={handleSubmitEditedUser}
          otp={otp}
          setOtp={setOtp}
          showResend={showResend}
          showTimer={showTimer}
          sendOtpFun={sendOtpFun}
          email={
            isDummySignup
              ? sessionStorage.getItem("dummy_email")
              : (formData?.email ?? "")
          }
          isDummySignup={isDummySignup}
          setStep={setStep}
        />
      )}
    </div>
  );
};

export default BasicInfoModal;
